{{#if allRuntimeFactoryTypeOverrides.length}}
virtual function void end_of_elaboration_phase(uvm_phase phase);
  super.end_of_elaboration_phase(phase);
{{#each allRuntimeFactoryTypeOverrides ln=true}}
  {{ base.type }}::type_id::set_type_override({{ override.type }}::get_type());
{{/each}}
endfunction
{{/if}}
